// Small pages also tolerate a server configured below Supabase's default 1,000 rows.
// Count is checked so a server-side cap cannot silently return partial totals.
export async function readDashboardPages(makeQuery, signal) {
  const rows = [];
  const size = 500;
  let total;
  for (let offset = 0; ; ) {
    if (signal?.aborted) throw new Error('Consulta cancelada');
    const { data, error, count } = await makeQuery().range(offset, offset + size - 1).abortSignal(signal);
    if (error) throw error;
    if (count != null) total = count;
    const page = data || [];
    rows.push(...page);
    offset += page.length;
    if (!page.length || (total != null ? offset >= total : page.length < size)) {
      if (total != null && offset < total) throw new Error('La consulta no devolvió todos los registros. Actualiza para reintentar.');
      return rows;
    }
  }
}
